import React from "react";
import Seo from "@/utils/seo";
import BannerCard from "@/components/ui/banner-card";
import Problem from "@/components/pages/initiatives/problem";
import Solution from "@/components/pages/initiatives/solution";
import SolutionGrid from "@/components/pages/initiatives/solution-grid";
import Divider from "@/components/pages/initiatives/divider";
import Head from "next/head";

export default function PVAWC() {
  const seo = {
    slug: "/prevention-of-violence-against-women-and-children",
    metaTitle:
      "Prevention of violence against women and children (PVAWC) | People’s Courage International, USA",
    metaDescription:
      "People’s Courage International works to end violence against women and children through strategies aiming at bringing individual, community, and systemic level outcomes. ",
  };
  const jsonLd = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "People’s Courage International",
    description:
      "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3206 10th Street NE, Washington",
      addressLocality: "DC",
      postalCode: "20017",
      addressCountry: "USA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1202-573-8727",
      contactType: "customer support",
    },
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Prevention of violence against women and children (PVAWC)",
          image: "/images/pwac/PVAWC-Top_inner_banner.webp",
        }}
        isActive={true}
        variant="single"
      />
      <Problem
        image="/images/pwac/problem.png"
        descriptionOne="Sex inequality is a fundamental challenge to development in South
            Asia, home to 860 million women, i.e., 22.6% of the global female
            population. Gender-based violence against women and girls across
            South Asia is multi-dimensional, and deeply rooted in inequitable
            socioeconomic structures, prevalent social norms and patriarchal
            attitudes. Despite having constitutional provisions and progressive
            legislation, women and children form the largest group of victims
            facing violence and discrimination."
        descriptionTwo="An estimated one in every two women in the region experience
            violence in their day-to-day lives and an estimated two-thirds of
            the world’s children who experienced severe violence are in South
            Asia. The violence faced and the lack of support systems is more
            acute for women and children from historically excluded communities."
      />
      <Solution
        image="/images/pwac/solution.jpg"
        description="The Grassroots Resilience Institute (GRI) seeks to partner with CBO’s across South and Southeast Asia and help solve for the specific challenges our partners face in sustaining their organizations. We will support partners through dedicated coaching and training on all aspects of organizational development, focusing on fundraising, financial and regulatory compliance, and programmatic clarity. Our partnership is our commitment to be:"
      />
      <SolutionGrid
        columns={2}
        data={[
          {
            title: "Prevention",
            image: "/images/pwac/prevention.png",
            description:
              "The organisations we work with employ strategies to work towards enhancing the skills and knowledge of women and girls that enable them to reject any forms of violence and discrimination.Besides, they focus on raising awareness about bodily autonomy, constitutional rights, rights against gender-based violence, and building leadership. This is done through various individual and community-level interventions.",
          },
          {
            title: "Response",
            image: "/images/pwac/response.png",
            description:
              "We support organizations that work towards filling the gaps in the laws by strengthening the systems and providing adequate legal, medical, psychological, emergency, and social assistance to survivors. The organizations provide pro bono legal services to survivors and assist with lodging complaints, opposing bails, availing compensation, and representing them before courts and commissions.",
          },
          {
            title: "Rehabilitation",
            image: "/images/pwac/support_women-1.png",
            description:
              "We support organizations that use a multi-dimensional approach to ensure survivors and their families can recover and reintegrate into society. This includes supporting them with their education and enrolling them in vocational and skill-building courses. The organizations provide psychological therapy from professional counselors to help survivors build resilience against trauma and stress from the violence suffered.",
          },
          {
            title: "System Reform",
            image: "/images/pwac/system_reform1.png",
            description:
              "We work with organizations that build strategic collaborations and partnerships with multiple stakeholders to ensure policy-level reforms. These collaborations include engaging with state officials such as police, members of One Stop Centers, child welfare committees, juvenile justice boards, shelter homes, lawyers, and judges to ensure their accountability and responsiveness while dealing with survivors of sexual violence.",
          },
        ]}
      />
      <Divider description="To address the large-scale prevalence of gender-based violence and the barriers faced by survivors to access justice across South Asia, People’s Courage International is working with organizations that collaborate with governments, civil society organizations, philanthropies, and other stakeholders towards building better response mechanisms at the regional level. People’s Courage International envisions 100 sexual violence-free districts across South Asia." />
    </>
  );
}
